import { apiConfig } from 'config';
import { handle420 } from 'apis/HandleError';
import { fetchdata } from '../FetchData';

export function getTwoHopAlignmentStatusInstances(alignmentId) {
  const url = apiConfig.commissionServiceGetTwoHopAlignmentStatusInstances(alignmentId);

  return fetchdata(url, { method: 'GET' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
